export class ConstantsBrowserLocalCache {
    public static readonly KeyCpbxUserName: string = "CpbxUnStr";
    public static readonly KeyCpbxUserBasicAuthString: string = "CpbxBaStr";
    public static readonly KeyCpbxUserProfileMe: string = "CpbxProfileMeJson";
    public static readonly KeyCpbxEnvName: string = "CpbxEnvName";
    public static readonly KeyCpbxProxyUrl: string = "CpbxProxyUrl";
    public static readonly KeyCpbxUserIvString: string = "CpbxUserIV";
    public static readonly KeyCpbxUserType: string = "CpbxUserType";
    public static readonly KeyCpbxHideWelcomeDialog: string = "CpbxSHideWelcomeDialog";
    public static readonly KeyCpbxHideDecommissionDialog: string = "CpbxSHideDecommissionDialog";
    public static readonly KeyCpbxHideVerhinderungAppNutzungDialog: string = "CpbxSHideVerhinderungAppNutzungDialog";
    public static readonly KeyM365UserObjectId: string = "CpbxM365UserObjectId";
    public static readonly KeyDataPrivStateLastUpdatedByUser: string = "CpbxDataPrivacyStateLastUpdatedByUserUtc";
    public static readonly KeyCiscoTokenForGroup: string = "CpbxCiscoTokenForGroup";
    public static readonly KeyAddressBookRecords: string = "CpbxAddressBookRecords";
    public static readonly KeyUpdateInfoSoftwareLastUpdated: string = "CpbxUpdateInfoSoftwareLastUpdatedByUserUtc";
    public static readonly KeyAddressBookRecordsPartPrefix: string = "CpbxAddressBookRecords_Part";
}
